export default __webpack_public_path__ + "static/media/hht2_sitcom_05.afb8c191.png";